import type { ConversationMessage } from "@/stores/conversation-message-types";
import { translate } from "@/i18n";
import { libChatMessages } from "@/i18n/messages/lib-chat";

export type DirectApprovalStatus = "pending" | "allowed" | "denied" | "expired";

const STATUSES: readonly DirectApprovalStatus[] = [
  "pending",
  "allowed",
  "denied",
  "expired",
];

function text(value: unknown): string {
  return typeof value === "string" ? value : "";
}

/** A coding session's relayed tool approval posted to the chat it was
 *  dispatched from, or undefined for other messages. */
export function directApprovalNotice(
  metadata: Record<string, unknown> | undefined,
): ConversationMessage["directApproval"] {
  const card = metadata?.direct_approval;
  if (typeof card !== "object" || card === null) return undefined;
  const data = card as Record<string, unknown>;
  const approvalId = text(data.approval_id);
  const projectId = text(data.project_id);
  const taskId = text(data.task_id);
  if (!approvalId || !projectId || !taskId) return undefined;
  const status = STATUSES.find((value) => value === data.status) ?? "pending";
  return {
    approvalId,
    projectId,
    taskId,
    title: text(data.title) || translate(libChatMessages, "approvalRequest"),
    description: text(data.description),
    status,
  };
}
